import { Component, OnInit, Input } from '@angular/core';
import { FiltrosFormatoAsistencialEntity, NodoEntity, FormatoAsistencialEntity,
  ServicioFormatoAsistencialService } from '../../../../services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FechaService } from '../../../../services/utils/fecha.service';

@Component({
  selector: 'app-signos-vitales',
  templateUrl: './signos-vitales.component.html',
  styleUrls: ['./signos-vitales.component.css']
})
export class SignosVitalesComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;
  descripcion: string;
  loading: boolean;
  signosVitales: SignosVitales;
  config: string[] = [];

  constructor( private servicioFormato: ServicioFormatoAsistencialService,
               private servicioFecha: FechaService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
      this.signosVitales = null;
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.descripcion = this.nodo.descripcion;
    this.config = this.getConfig(this.nodo.valor);
    this.getSignosVitales(this.filtros.codigoBaseDatos, this.filtros.tta);
  }

  // Metodo encargado de obtener los signos vitales a mostrar
  getConfig(value: string): string[] {
    let config = value;
      config = config.replace('fields', '');
      config = config.replace('{', '');
      config = config.replace('}', '');
      config = config.replace(':', '');
      config = config.replace(/["']/g, '');
      config = config.replace(/,/g, '');
      config = config.replace(/%03/gi, ',');
    return config.split(',').filter((s: any) => s);
  }

  async getSignosVitales(db: string, tta: number) {
    try {
      this.loading = true;
      const response = await this.servicioFormato.getSignosVitalesAsistencial(db, tta);
      if (response != null) {
        response.subscribe((data: SignosVitales) => {
          this.signosVitales = data;
          this.loading = false;
          if (this.isEmptySignosVitales() && this.filtros.diligenciados){
            setTimeout(() => {
              this.onDelete();
            }, 50);
          }
        }, (err: HttpErrorResponse) => {
          this.signosVitales = {};
          this.loading = false;
          console.error('Error Control Signos Vitales', err);
        });
      }
    } catch (e) {
      this.signosVitales = {};
      console.error('Catch Control Signos Vitales', e);
    }
  }

  // Responde si un signo vital esta configurado para mostrarse
  isEnabled(sv: string): boolean {
    return this.config.find((s: string) => s === sv) ? true : false;
  }

  // Obtiene el valor de un signo vital
  getValue(sv: string): number {
    switch (sv) {
      case '1' : {
        return this.signosVitales ? this.signosVitales.tensionArterialAlta : 0;
      }

      case '2' : {
        return this.signosVitales ? this.signosVitales.tensionArterialBaja : 0;
      }

      case '3' : {
        return this.signosVitales ? this.signosVitales.frecuenciaCardiaca : 0;
      }

      case '4' : {
        return this.signosVitales ? this.signosVitales.frecuenciaRespiratoria : 0;
      }

      case '5' : {
        return this.signosVitales ? this.signosVitales.perimetroCraneal : 0;
      }

      case '6' : {
        return this.signosVitales ? this.signosVitales.temperatura : 0.0;
      }

      case '7' : {
        return this.signosVitales ? this.signosVitales.peso : 0.0;
      }

      case '8' : {
        return this.signosVitales ? this.signosVitales.talla : 0.0;
      }

      case '9' : {
        return this.signosVitales ? this.signosVitales.imc : 0.0;
      }

      case '10' : {
        return this.signosVitales ? this.signosVitales.perimetroToraxico : 0.0;
      }

      default : return 0;
    }
  }

  // Retorna la edad del afiliado
  getEdad() {
    const fechaNacimiento = new Date(this.data.afiliado.fechaNacimiento);
    const fechaAtencion = new Date(this.data.fechaAtencion);
    const difference = this.servicioFecha.getDifferenceInYears(fechaNacimiento, fechaAtencion);
    return difference;
  }

  // Indica si se debe mostrar la clasificacion hta
  isEnabledHTA(): boolean {
    return this.signosVitales && (this.isEnabled('1') || this.isEnabled('2'));
  }

  // Indica si se debe mostrar el imc
  isEnabledIMC(): boolean {
    const imc = this.isEnabled('9');
    const edad = this.getEdad();
    return imc && edad < 18;
  }

  // Indica si se debe mostrar la clasificacion
  isEnabledClasificacion(): boolean {
    const imc = this.isEnabled('9');
    const edad = this.getEdad();
    return imc && edad >= 18;
  }

  // Indica la cantidad de colspan para  (HTA, Clasificacion, IMC)
  getColspan(type: number, pos ?: number): number {
    switch (type) {
      case 1: return this.config.length; // HTA, IMC
      case 2: { // Clasificacion
        const cantidad = this.config.length;
        if (cantidad % 2 === 0) {
          return cantidad / 2;
        } else {
          return Math.floor(cantidad / 2) + (pos === 0 ? 1 : 0);
        }
      }
      default : return 1;
    }
  }

  // Indica el color de la celda
  getClass(sv: number): string {
    switch (sv) {
      case 1:
      case 2:
      case 3:
      case 4: {
        return this.getIndicadorReferencia(sv, sv);
      }
      case 6: {
        return this.getIndicadorReferencia(sv, 5);
      }
      default: break;
    }
    return 'bg-primary text-white';
  }

  getIndicadorReferencia(valueRef: number, ref: number): string{
    const edad = this.getEdad();
    const referencias = this.signosVitales && this.signosVitales.referencias ? this.signosVitales.referencias : null;
    if (referencias) {
      const referencia = referencias.find((r: ReferenciaSignosVitales) => {
        return r.indicadorReferencia === ref && edad >= r.edadInicial && edad <= r.edadFinal;
      });

      if (referencia) {
        const value = this.getValue(String(valueRef));
        return value >= referencia.rangoInicial && value <= referencia.rangoFinal ? 'bg-success text-white' : 'bg-danger text-white';
      }
    }
    return 'bg-primary text-white';
  }

  isEmptySignosVitales(): boolean {
    return this.signosVitales.tensionArterialAlta === 0 && 
      this.signosVitales.tensionArterialBaja === 0 &&
      this.signosVitales.frecuenciaCardiaca === 0 &&
      this.signosVitales.frecuenciaRespiratoria === 0 &&
      this.signosVitales.perimetroCraneal === 0 &&
      this.signosVitales.temperatura === 0 &&
      this.signosVitales.peso === 0 &&
      this.signosVitales.talla === 0;
  }

  onDelete() {  }

}

interface SignosVitales {
  tensionArterialAlta ?: number;
  tensionArterialBaja ?: number;
  frecuenciaCardiaca ?: number;
  frecuenciaRespiratoria ?: number;
  temperatura ?: number;
  peso ?: number;
  talla ?: number;
  imc ?: number;
  perimetroCraneal ?: number;
  perimetroToraxico ?: number;
  statusIMC ?: string;
  clasificacion ?: number;
  riesgo ?: string;
  clasificacionHipertension ?: string;
  clasificacionValue ?: string;
  referencias ?: ReferenciaSignosVitales[];
}

interface ReferenciaSignosVitales {
  indicadorReferencia: number;
  edadInicial: number;
  edadFinal: number;
  rangoInicial: number;
  rangoFinal: number;
}
